<script lang="ts">
    import {createEventDispatcher} from "svelte";
    import {Button, Spinner} from "flowbite-svelte";
    import {BuildingSolid, PenSolid, TrashBinSolid} from "flowbite-svelte-icons";

    export let showEdit = false;

    export let disabled = false;

    export let nextText = 'Weiter';

    const dispatch = createEventDispatcher();
</script>

<div class="flex gap-3 justify-between w-full">
    <div class="flex gap-2">
        <slot name="left">
            <Button {disabled} outline color="red" on:click={() => dispatch('abort')}>
                <TrashBinSolid class="w-4 h-4 me-2"/> <span>Abbrechen</span>
            </Button>
            {#if showEdit}
                <Button {disabled} outline on:click={() => dispatch('edit')}>
                    <PenSolid class="w-4 h-4 me-2"/> Bearbeiten
                </Button>
            {/if}
        </slot>

    </div>
    <div class="place-self-center">
        {#if disabled}
            <Spinner />
        {/if}
    </div>
    <div class="flex gap-2">
        <slot name="right">
            <Button disabled={disabled} class="bg-sky-100 text-neutral-700 whitespace-nowrap" on:click={() => dispatch('next')}><BuildingSolid class="w-4 mr-2"/>{nextText}</Button>
        </slot>
    </div>


</div>